<template>
  <div class="resources-feed__filters-wrapper">
    <div
      class="resources-feed__filters resources-filters resources-filters--desktop"
    >
      <span>Filter your search:</span>
      <button
        class="resources-filters__taxonomy"
        :class="
          activeTaxonomy === taxonomy.taxonomy_name
            ? 'resources-filters__taxonomy--active'
            : ''
        "
        v-for="taxonomy in taxonomies"
        :key="taxonomy.taxonomy_name"
        :title="taxonomy.taxonomy_name"
        @click="showTerms(taxonomy.taxonomy_name)"
      >
        {{ taxonomy.taxonomy_name }}
      </button>
      <div class="resources-filters__selected-filters" v-if="Object.keys(currentTaxonomies).length !== 0">
        <span>Filters currently selected: </span>
        <div v-for="(terms, index) in currentTaxonomies" :key="index">
          <span v-for="(term, i) in terms" :key="i">{{ term }}</span>
        </div>
        <button class="resources-filters__clear" title="Clear Filters" v-if="Object.keys(currentTaxonomies).length !== 0" @click="clearCurrentTaxonomies" />
      </div>
    </div>
    <div
      class="resources-filters__wrapper resources-filters__wrapper--desktop container--1240"
    >
      <template v-for="(taxonomy, index) in taxonomies">
        <div
          class="resources-filters__terms"
          v-if="activeTaxonomy === taxonomy.taxonomy_name"
          :key="index"
        >
          <button
            class="resources-filters__term"
            v-for="term in taxonomy.terms"
            :key="term.term_id"
            :title="term.name"
            :class="{
              'resources-filters__term--active':
                Object.hasOwn(currentTaxonomies, term.taxonomy) &&
                currentTaxonomies[term.taxonomy].includes(term.name),
            }"
            @click="selectTerm(term), toggleClass($event)"
          >
            {{ term.name }}
          </button>
        </div>
      </template>
    </div>
    <div
      class="resources-feed__filters resources-filters resources-filters--mobile"
      :class="{ 'resources-filters--active': showFilters }"
    >
      <div class="resources-filters__top">
        <span>Filter your search:</span>
        <button
          class="resources-filters__taxonomy"
          :class="
            activeTaxonomy === taxonomy.taxonomy_name
              ? 'resources-filters__taxonomy--active'
              : ''
          "
          v-for="taxonomy in taxonomies"
          :key="taxonomy.taxonomy_name"
          :title="taxonomy.taxonomy_name"
          @click="showTerms(taxonomy.taxonomy_name)"
        >
          {{ taxonomy.taxonomy_name }}
        </button>
      </div>
      <div
        class="resources-filters__selected-filters"
        v-if="Object.keys(currentTaxonomies).length > 0"
      >
        <span>Filters currently selected: </span>
        <div v-for="(terms, index) in currentTaxonomies" :key="index">
          <span v-for="(term, i) in terms" :key="i">{{ term }}</span>
        </div>
        <button class="resources-filters__clear" title="Clear Filters" v-if="Object.keys(currentTaxonomies).length !== 0" @click="clearCurrentTaxonomies" />
      </div>
      <div
        class="resources-filters__wrapper resources-filters__wrapper--mobile"
      >
        <template v-for="(taxonomy, index) in taxonomies">
          <div
            class="resources-filters__terms"
            v-if="activeTaxonomy === taxonomy.taxonomy_name"
            :key="index"
          >
            <button
              class="resources-filters__term"
              v-for="term in taxonomy.terms"
              :key="term.term_id"
              :title="term.name"
              :class="{
                'resources-filters__term--active':
                  Object.hasOwn(currentTaxonomies, term.taxonomy) &&
                  currentTaxonomies[term.taxonomy].includes(term.name),
              }"
              @click="selectTerm(term), toggleClass($event)"
            >
              {{ term.name }}
            </button>
          </div>
        </template>

        <button
          class="btn btn--large btn--orange resources-filters__button"
          title="Apply Filters"
          @click="showFilters = false"
        >
          Apply Filters
        </button>
      </div>
    </div>
    <button
      class="resources-filters__filter btn btn--purple btn--smallest"
      title="Filter your search"
      @click="showFilters = true"
    >
      Filter your search
    </button>
  </div>
</template>

<script>
import store from '../store/store';

import { mapGetters } from 'vuex';

export default {
  name: 'Filters',
  store: store,
  data: () => ({
    activeTaxonomy: '',
    showFilters: false
  }),
  methods: {
    toggleClass (event) {
      event.target.classList.toggle('resources-filters__term--active');
    },
    clearCurrentTaxonomies () {
      store.dispatch('rf/setFilters', {});
      store.dispatch('rf/updateURL');
      store.dispatch('rf/resetFeed');
      store.dispatch('rf/returnResources');
    },
    selectTerm (term) {
      store.dispatch('rf/updateCurrentTaxonomies', term);
      if (Object.keys(this.currentTaxonomies).length === 0) {
        store.dispatch('rf/clearURL');
      } else {
        store.dispatch('rf/updateURL');
      }

      store.dispatch('rf/resetFeed');
      store.dispatch('rf/returnResources');
    },
    showTerms (taxonomyName) {
      this.activeTaxonomy =
        this.activeTaxonomy === taxonomyName ? '' : taxonomyName;
    }
  },
  mounted () {
    store.dispatch('rf/returnTaxonomies');
    if (this.$route.query.filters) {
      store.dispatch('rf/setFilters', JSON.parse(this.$route.query.filters));
    }
  },
  computed: {
    ...mapGetters({
      currentTaxonomies: 'rf/getCurrentTaxonomies',
      taxonomies: 'rf/getTaxonomies',
      activeTerms: 'rf/getActiveTerms'
    })
  }
};
</script>

<style></style>
